import React from "react";
import data from "../../../template/copy.json";
// import logo from "../../assets/logo_white.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div
        dangerouslySetInnerHTML={{
          __html: data.footer.text.split("\n").join("<br />"),
        }}
      ></div>
    </footer>
  );
};

export default Footer;
